import styled from '@emotion/styled'

import HeroBase, * as HeroRecipe from '@segment/matcha/recipes/Hero'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

const copy = {
  heading: `How can we help you?`,
  description: `Choose a category below to email the support team so we can get back to you as quickly as possible.`,
}

const Hero = () => {
  return (
    <Wrapper>
      <StyledHeroBase variant="centered">
        <HeroRecipe.Copy>
          <CopyTextBase centered={true}>
            <CopyText.Heading tag="h1" variant="h1">
              {copy.heading}
            </CopyText.Heading>
            <CopyText.Description tag="p" variant="pExtraLarge">
              {copy.description}
            </CopyText.Description>
          </CopyTextBase>
        </HeroRecipe.Copy>
      </StyledHeroBase>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.palette.twilio.green[10]};
`

const StyledHeroBase = styled(HeroBase)`
  ${HeroRecipe.Wrapper} {
    row-gap: 0;
    padding-top: 120px;
  }
`

export default Hero
